export type QueryParamValue = string | number | boolean | null | undefined

export function buildQueryString(params: Record<string, QueryParamValue>) {
  const query = new URLSearchParams()

  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === '') continue
    query.set(key, String(value))
  }

  return query.toString()
}
